import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Panel} from "primereact/panel";
import {FileUpload} from "primereact/fileupload";
import {Dropdown} from "primereact/dropdown";
import axios from "axios";

import {InputSwitch} from "primereact/inputswitch";

const CompanyFormComponent = (props) => {
  const {t} = props;

  const [formData, setFormData] = useState({
    address_country_code: "HU",
  });
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [receiptGroups, setReceiptGroups] = useState([]);
  const [logoUrl, setLogoUrl] = useState(null);

  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    // if (!data.vat_number) {
    //   errors.vat_number = 'Az adószám nem lehet üres';
    // }
    return errors;
  };

  const onSubmit = (data, form) => {
    setLoading(true)
    const roles_str = (localStorage.getItem('roles') || '').toString();
    const can_update = roles_str.includes('role_company_update');
    const can_create = roles_str.includes('role_company_create');
    const is_update_mode = !!(props && props.initialValues && props.initialValues.id) || !!formData.id;
    if (is_update_mode && !can_update) {
      window.App.toastShow('error', t('toastError'), t('permissionUpdateDenied'));
      setLoading(false);
      return;
    }
    if (!is_update_mode && !can_create) {
      window.App.toastShow('error', t('toastError'), t('permissionCreateDenied'));
      setLoading(false);
      return;
    }
    setFormData({
      ...formData,
      ...data
    });
    const payload = {
        name: data.name,
        type: data.type,
        vat_number: data.vat_number,
        community_vat_number: data.community_vat_number,
        registration_number: data.registration_number,
        email: data.email,
        receipt_other_data: data.receipt_other_data,
        tax_free: !!data.tax_free,
        address_country_code: data.address_country_code,
        address_postal_code: data.address_postal_code,
        address_city: data.address_city,
        address_detail: data.address_detail
    };
    if (props && props.initialValues) {
      apiCall('patch', `/api/v2/company/${formData.id}`, payload)
        .then(response => {
          window.App.toastShow('success', t('toastUpdateSuccess'));
          window.App.setState({
            rerenderCompanyList: true,
            sidebarCompanyUpdate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      apiCall('post', `/api/v2/company`, data)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({
            rerenderCompanyList: true,
            sidebarCompanyCreate: false
          })
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', t('toastError'), error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const loadCompany = (companyId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company/" + companyId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    }).then(r => r.data.data);
  };

  const loadCompanyNav = (companyId) => {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company-nav/" + companyId,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    }).then(r => r.data.data);
  };

  const loadAllCompanyData = (companyId) => {
    return loadCompany(companyId)
      .then(async (company) => {
        if (process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true') {
          try {
            const nav = await loadCompanyNav(companyId);
            return { ...company, ...nav };
          } catch (e) {
            return company;
          }
        }
        return company;
      })
      .then((merged) => {
        if (merged.nav_invoice_receipt_group && typeof merged.nav_invoice_receipt_group === 'object') {
          merged.nav_invoice_receipt_group = merged.nav_invoice_receipt_group.id;
        }
        setFormData(merged);
        return merged;
      });
  };

  const saveNavSettings = () => {
    setLoading(true);
    return axios({
      method: 'patch',
      url: process.env.REACT_APP_API_HOST + "/api/v2/company-nav/" + formData.id,
      data: {
        nav_test: !!formData.nav_test,
        nav_user_name: formData.nav_user_name || null,
        nav_user_pass: formData.nav_user_pass || null,
        nav_x_m_l_sign_key: formData.nav_x_m_l_sign_key || null,
        nav_x_m_l_exchange_key: formData.nav_x_m_l_exchange_key || null,
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(() => {
        window.App.toastShow('success', t('toastSaveSuccess'));
        return loadAllCompanyData(formData.id);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };


  // image
  const imageUpload = async (files) => {
    const f = files?.files?.[0];
    if (!f) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append('file', f);
      const up = await axios.post(
        process.env.REACT_APP_API_HOST + '/api/v2/file/upload',
        fd,
        {
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('userToken'),
            'App-Network': localStorage.getItem('networkId'),
          }
        }
      );
      const newFileId = up?.data?.data?.id ?? up?.data?.id;
      if (!newFileId) throw new Error('Nem érkezett file id a feltöltésből.');
      await apiCall('patch', `/api/v2/company/${formData.id}`, { 
        // ...formData,
        logo: Number(newFileId) 
      });
      window.App.toastShow('success', 'Sikeres logó feltöltés');
      loadAllCompanyData(formData.id);
    } catch (err) {
      window.App.toastShow('error', 'Hiba történt!', err.toString());
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/receipt-group?search[receipt_type][operator]==&search[receipt_type][value]=SUPPLIER_INVOICE", {
      headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
      }
    })
    .then(response => {
      setReceiptGroups(response.data.data.items || [])
    })
    .catch(error => console.error("Receipt groups error", error));
    // CompanytypeListService()
    //   .then(response => {
    //     setCompanyTypes(response.data)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
    //   })
    // CountryListService(JSON.stringify({
    //   first: 0,
    //   rows: 9999,
    //   page: 0,
    // }))
    //   .then(response => {
    //     setCountries(response.data)
    //   })
    //   .catch(error => {
    //     window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
    //   })
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/country", {
      headers: {
          'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
          'App-Network': localStorage.getItem("networkId")
        }    
      })
      .then(response => {
        setCountries(response.data.data || [])
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
    if ((props.initialValues && props.initialValues.id) || formData.id) {
      let id
      if (formData.id) {
        id = formData.id
      }
      if (props.initialValues.id) {
        id = props.initialValues.id
      }
      // CompanydocumentListService('', id)
      // CompanycontactListService('', id)
    }
    if (props && props.initialValues && props.initialValues.id) {
      loadAllCompanyData(props.initialValues.id)
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        });
    }
  }, [])

  useEffect(() => {
    let alive = true;
    let objectUrl = null;
    const loadLogo = async () => {
      const logoId = formData.logo?.id || formData.logo;
      if (!logoId) { setLogoUrl(null); return; }
      const res = await axios.get(
        process.env.REACT_APP_API_HOST + `/api/v2/file/${logoId}/download`,
        {
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken"),
            "App-Network": localStorage.getItem("networkId"),
          },
        }
      );
      objectUrl = URL.createObjectURL(res.data);
      if (alive) setLogoUrl(objectUrl);
    };
    loadLogo().catch(() => setLogoUrl(null));
    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [formData.logo, formData.id]);

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit, submitting}) => (
      <form onSubmit={handleSubmit} className="">
        {localStorage.getItem('roles').toString().includes('role_company_update') &&
        <Panel headerTemplate={
          <div className={"p-grid"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-list"}></i> {props.t('tabBasicData')}
              </h3>
            </div>
          </div>
        } className={""}>
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-8"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/* <div className={"p-col-12 p-lg-4"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompanyType')}</label>
                  <span className="p-d-block">
                      <Dropdown options={window.App.sortDropdownOptions(companyTypes, "name")}
                                {...input}
                                optionLabel="name"
                                optionValue="id"
                                id={"type"}
                                emptyMessage={props.t('noCompanyFormYet')}
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    type: e.value
                                  })
                                }}
                                value={formData.type}
                                className={classNames({'p-invalid': isFormFieldValid(meta)})}
                      />
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div> */}
            <div className={"p-col-12 p-lg-4"}>
              <Field name="vat_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="vat_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldVatNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="vat_number" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     vat_number: e.target.value
                                   })
                                 }}
                                 value={formData.vat_number}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="community_vat_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="community_vat_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCommunityVatNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="community_vat_number"
                                 {...input}
                                 value={formData.community_vat_number}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     community_vat_number: e.target.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="registration_number" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="registration_number"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldRegistrationNumber')}</label>
                  <span className="p-d-block">
                      <InputText id="registration_number"
                                 {...input}
                                 value={formData.registration_number}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     registration_number: e.target.value
                                   })
                                 }}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="email" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="email"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCentralEmail')}</label>
                  <span className="p-d-block">
                      <InputText id="email" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     email: e.target.value
                                   })
                                 }}
                                 value={formData.email}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="receipt_other_data" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="receipt_other_data"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldReceiptOtherData')}</label>
                  <span className="p-d-block">
                      <InputText id="receipt_other_data" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     receipt_other_data: e.target.value
                                   })
                                 }}
                                 value={formData.receipt_other_data}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="tax_free" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="tax_free"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldTaxFree')}</label>
                  <span className="p-d-block">
                        <InputSwitch
                          className={"p-mt-1"}
                          checked={!!formData.tax_free}
                          value={!!formData.tax_free}
                          onChange={e => setFormData({...formData, tax_free: e.target.value})}/>
                      </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12"}>
              <h3>
                <i className={"pi pi-map-marker"}></i> Székhely
              </h3>
            </div>
          </div>

          <div className={"p-grid"}>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_country_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_country_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCountry')}</label>
                  <span className="p-d-block">
                    <Dropdown options={window.App.sortDropdownOptions(countries, "name")}
                              optionLabel="name"
                              optionValue="code"
                              id={"address_country_code"}
                              emptyMessage={props.t('noCountryYet')}
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  address_country_code: e.value
                                })
                              }}
                              value={formData.address_country_code}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-2 p-lg-2"}>
              <Field name="address_postal_code" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_postal_code"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressPostalCode')}</label>
                  <span className="p-d-block">
                      <InputText id="address_postal_code" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_postal_code: e.target.value
                                   })
                                 }}
                                 value={formData.address_postal_code}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-3 p-lg-3"}>
              <Field name="address_city" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_city"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCity')}</label>
                  <span className="p-d-block">
                      <InputText id="address_city" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_city: e.target.value
                                   })
                                 }}
                                 value={formData.address_city}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-md-4 p-lg-4"}>
              <Field name="address_detail" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="address_detail"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressDetail')}</label>
                  <span className="p-d-block">
                      <InputText id="address_detail" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     address_detail: e.target.value
                                   })
                                 }}
                                 value={formData.address_detail}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
              <Button type="submit" label={props.t('save')} icon="pi pi-check" loading={loading}
                      className="p-button-success"/>
            </div>
          </div>
        </Panel>
        }
        {formData.id && process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-sync"}></i> NAV Interfész
                </h3>
              </div>
            </div>
          } className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_user_name">{props.t('fieldNavUserName')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_user_name"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_user_name: e.target.value
                                 })
                               }}
                               value={formData.nav_user_name || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_user_pass">{props.t('fieldNavUserPass')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_user_pass"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_user_pass: e.target.value
                                 })
                               }}
                               value={formData.nav_user_pass || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_x_m_l_sign_key">{props.t('fieldNavXmlSignKey')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_x_m_l_sign_key"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_x_m_l_sign_key: e.target.value
                                 })
                               }}
                               value={formData.nav_x_m_l_sign_key || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_x_m_l_exchange_key">{props.t('fieldNavXmlExchangeKey')}</label>
                  <span className={"p-d-block"}>
                    <InputText id="nav_x_m_l_exchange_key"
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   nav_x_m_l_exchange_key: e.target.value
                                 })
                               }}
                               value={formData.nav_x_m_l_exchange_key || ""}/>
                  </span>
                </div>
              </div>
              <div className={"p-col-12 p-lg-3 p-xl-3"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_test">{props.t('fieldNavTest')}</label>
                  <span className={"p-d-block"}>
                    <InputSwitch
                      id="nav_test"
                      className={"p-mt-1"}
                      checked={!!formData.nav_test}
                      value={!!formData.nav_test}
                      onChange={e => setFormData({...formData, nav_test: e.target.value})}/>
                  </span>
                </div>
              </div>
            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label={props.t('save')} icon="pi pi-check"
                        className={"p-button-success"}
                        onClick={() => {
                          saveNavSettings();
                        }}
                        loading={loading}/>
              </div>
            </div>
          </Panel>
        </>
        }
        {formData.id && process.env.REACT_APP_COMPANY_NAV_INTERFACE === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-sync"}></i> NAV adatszolgáltatás
                </h3>
              </div>
            </div>
          }
          className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col-12 p-lg-12 p-xl-12"}>
                <div className="p-field p-fluid">
                  <label htmlFor="auto_import_nav_invoices">{props.t('fieldAutoImportNavInvoices')}</label>
                  <span className={"p-d-block"}>
                    <InputSwitch
                      id="auto_import_nav_invoices"
                      className={"p-mt-1"}
                      checked={!!formData.auto_import_nav_invoices}
                      value={!!formData.auto_import_nav_invoices}
                      onChange={e => setFormData({...formData, auto_import_nav_invoices: e.target.value})}/>
                  </span>
                </div>
              </div>
              {!!formData.auto_import_nav_invoices && (
              <div className={"p-col-12 p-lg-6"}>
                <div className="p-field p-fluid">
                  <label htmlFor="nav_invoice_receipt_group">{props.t('fieldNavInvoiceReceiptGroup')}</label>
                  <span className={"p-d-block"}>
                    <Dropdown 
                      options={window.App.sortDropdownOptions(receiptGroups, "name")}
                      optionLabel="name"
                      optionValue="id"
                      id={"nav_invoice_receipt_group"}
                      emptyMessage={props.t('noReceiptGroupYet')}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          nav_invoice_receipt_group: e.value
                        })
                      }}
                      value={formData.nav_invoice_receipt_group}
                      placeholder={props.t('selectBlockPlaceholder')}/>
                  </span>
                </div>
              </div>
              )}
              
            </div>
            <div className={"p-grid p-mt-1"}>
              <div className={"p-col-12 p-lg-6 p-xl-6"}>
              </div>
              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                <Button type="button" label={props.t('save')} icon="pi pi-check"
                        className={"p-button-success"}
                        onClick={() => {
                        setLoading(true);
                        axios({
                          method: 'patch',
                          url: process.env.REACT_APP_API_HOST + "/api/v2/company/" + formData.id,
                          data: {
                            auto_import_nav_invoices: !!formData.auto_import_nav_invoices,
                            nav_invoice_receipt_group: formData.nav_invoice_receipt_group || null
                          },
                          headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
                            'App-Network': localStorage.getItem("networkId")
                          }
                        })
                        .then(() => {
                          window.App.toastShow('success', t('toastSaveSuccess'));
                          loadAllCompanyData(formData.id);
                        })
                        .catch(error => {
                          window.App.toastShow('error', t('toastError'), error.toString());
                        })
                          .finally(() => setLoading(false));
                        }}
                        loading={loading}/>
              </div>
            </div>
          </Panel>
        </>
        }
        {formData.id && process.env.REACT_APP_COMPANY_LOGO === 'true' &&
        <>
          <Panel headerTemplate={
            <div className={"p-grid"}>
              <div className={"p-col-12"}>
                <h3>
                  <i className={"pi pi-image"}></i> Logó
                </h3>
              </div>
            </div>
          } className={"p-mt-3"}>
            <div className={"p-grid"}>
              <div className={"p-col"}>
                <div className="p-field p-fluid p-mb-3 p-text-left">
                  <label htmlFor="file">{props.t('fieldUploadedLogo')}</label>
                  {logoUrl ? (
                    <div className="p-mt-2">
                      <img  src={logoUrl} className={"w-75"} style={{ maxHeight: '200px', objectFit: 'contain' }} alt="Céglogó" />
                    </div>
                  ) : (
                    <p className="p-text-muted p-mt-2">Nincs feltöltött logó.</p>
                  )}
                </div>
              </div>
              <div className={"p-col"}>
                {!formData.logo && 
                <div className="p-field p-fluid">
                  <label htmlFor="file">{props.t('fieldImageUpload')}</label>
                  <span className="p-d-block">
                            <FileUpload mode="basic"
                                        name="file"
                                        id={"file"}
                                        auto="false"
                                        customUpload
                                        uploadHandler={imageUpload}
                                        chooseLabel={props.t('chooseFile')}
                                        uploadLabel={props.t('upload')}
                                        className={""}
                            />
                        </span>
                </div>
                }
                <div className="p-field p-mt-3">
                  <label htmlFor="file">{props.t('fieldImageDelete')}</label>
                  <span className="p-d-block">
                        <Button type="button"
                          className="p-button p-button-danger"
                          onClick={() => {
                            if (!window.confirm(t('confirmDelete'))) return;
                            setLoading(true);
                            apiCall('patch', `/api/v2/company/${formData.id}`, { 
                              name: formData.name, 
                              logo: null 
                            })
                            .then(() => {
                              window.App.toastShow('success', t('toastDeleteSuccess'));
                              loadAllCompanyData(formData.id);
                            })
                            .catch(error => {
                              window.App.toastShow('error', t('toastError'), error.toString());
                            })
                            .finally(() => setLoading(false));
                          }}
                          >
                            <i className={"pi pi-trash"}></i>&nbsp;{t('delete')}
                          </Button>
                        </span>
                </div>
              </div>
            </div>
          </Panel>
        </>
        }
        {/*{localStorage.getItem('roles').toString().includes('role_company_document_read') &&*/}
        {/*<Panel headerTemplate={*/}
        {/*  <div className={"p-grid"}>*/}
        {/*    <div className={"p-col-12"}>*/}
        {/*      <h3>*/}
        {/*        <i className={"pi pi-list"}></i> Dokumentumok*/}
        {/*      </h3>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*} className={"p-mt-3"}>*/}
        {/*  {documents && documents[0] &&*/}
        {/*  <DataTable size={localStorage.getItem('scale')} value={documents}*/}
        {/*             emptyMessage={props.t('noResults')}*/}
        {/*             autoLayout={true}*/}
        {/*             filterDisplay="row"*/}
        {/*             responsiveLayout="scroll"*/}
        {/*             stripedRows*/}
        {/*             className={"p-mb-3"}*/}
        {/*  >*/}
        {/*    <Column field="name" header="Név"></Column>*/}
        {/*    <Column field="filePath" header="Fájl" body={(rowData) => {*/}
        {/*      return (*/}
        {/*        <>*/}
        {/*          <a*/}
        {/*            href={process.env.REACT_APP_API_HOST + "/companyDocument/download/" + rowData.id*/}
        {/*            + "?token=" + localStorage.getItem('userToken') + "."*/}
        {/*            + localStorage.getItem("networkId")}*/}
        {/*            target="_blank"*/}
        {/*          >*/}
        {/*            <i className={"pi pi-file"}></i> {rowData.originalFileName}*/}
        {/*          </a>*/}
        {/*        </>*/}
        {/*      )*/}
        {/*    }}></Column>*/}
        {/*    /!*<Column body={itemActionBody} className={"p-text-right p-text-nowrap"}></Column>*!/*/}
        {/*  </DataTable>*/}
        {/*  }*/}
        {/*  <div className={"p-grid"}>*/}
        {/*    <div className={"p-col-12 p-lg-6 p-xl-6 p-col-align-center"}>*/}
        {/*      {documents && !documents[0] &&*/}
        {/*      <>Nincs dokumentum.</>*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*    <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>*/}
        {/*      {localStorage.getItem('roles').toString().includes('role_company_document_write') &&*/}
        {/*      <Button type="button" label="Új dokumentum hozzáadása" icon="pi pi-plus" className="p-button-success "*/}
        {/*              onClick={() => {*/}
        {/*                setDocumentDialog(true)*/}
        {/*                setDocumentFormMethod('post')*/}
        {/*              }}*/}
        {/*      />*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Panel>*/}
        {/*}*/}
        {/*{localStorage.getItem('roles').toString().includes('role_company_contact_read') &&*/}
        {/*<Panel headerTemplate={*/}
        {/*  <div className={"p-grid"}>*/}
        {/*    <div className={"p-col-12"}>*/}
        {/*      <h3>*/}
        {/*        <i className={"pi pi-list"}></i> Kapcsolattartók*/}
        {/*      </h3>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*} className={"p-mt-3"}>*/}
        {/*  {contacts && contacts[0] &&*/}
        {/*  <DataTable size={localStorage.getItem('scale')} value={contacts}*/}
        {/*             emptyMessage={props.t('noResults')}*/}
        {/*             autoLayout={true}*/}
        {/*             filterDisplay="row"*/}
        {/*             responsiveLayout="scroll"*/}
        {/*             stripedRows*/}
        {/*             className={"p-mb-3"}*/}
        {/*  >*/}
        {/*    {localStorage.getItem('roles').toString().includes('role_company_contact_write') &&*/}
        {/*    <Column body={contactActionBody} className={"p-text-nowrap"}></Column>*/}
        {/*    }*/}
        {/*    <Column field="name" header="Név"></Column>*/}
        {/*    <Column field="email" header="Email"></Column>*/}
        {/*    <Column field="phone" header="Telefon"></Column>*/}
        {/*  </DataTable>*/}
        {/*  }*/}
        {/*  <div className={"p-grid"}>*/}
        {/*    <div className={"p-col-12 p-lg-6 p-xl-6 p-col-align-center"}>*/}
        {/*      {contacts && !contacts[0] &&*/}
        {/*      <>Nincs kapcsolat.</>*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*    <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>*/}
        {/*      {localStorage.getItem('roles').toString().includes('role_company_contact_write') &&*/}
        {/*      <Button type="button" label="Új kapcsolat hozzáadása" icon="pi pi-plus" className="p-button-success "*/}
        {/*              onClick={() => {*/}
        {/*                setContactDialog(true)*/}
        {/*                setContactFormMethod('post')*/}
        {/*              }}*/}
        {/*      />*/}
        {/*      }*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</Panel>*/}
        {/*}*/}
        {/*<Dialog visible={documentDialog}*/}
        {/*        style={{width: '750px'}}*/}
        {/*        header="Dokumentum hozzáadása"*/}
        {/*        modal*/}
        {/*        onHide={() => {*/}
        {/*          setDocumentDialog(false)*/}
        {/*        }}>*/}
        {/*  <Form onSubmit={documentOnSubmit}*/}
        {/*        initialValues={documentFormData}*/}
        {/*        validate={documentValidate}*/}
        {/*        render={({handleSubmit, submitting}) => (*/}
        {/*          <form onSubmit={handleSubmit} className="">*/}
        {/*            <div className={"p-grid"}>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6"}>*/}
        {/*                <div className={"p-grid"}>*/}
        {/*                  <div className={"p-col-12 p-lg-12 p-xl-12"}>*/}
        {/*                    <Field name="name" render={({input, meta}) => (*/}
        {/*                      <div className="p-field p-fluid">*/}
        {/*                        <label htmlFor="name"*/}
        {/*                               className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>*/}
        {/*                        <span className={"p-d-block"}>*/}
        {/*                      <InputText id="name" {...input}*/}
        {/*                                 onChange={(e) => {*/}
        {/*                                   setDocumentFormData({*/}
        {/*                                     ...documentFormData,*/}
        {/*                                     name: e.target.value*/}
        {/*                                   })*/}
        {/*                                 }}*/}
        {/*                                 value={documentFormData.name}*/}
        {/*                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
        {/*                    </span>*/}
        {/*                        {getFormErrorMessage(meta)}*/}
        {/*                      </div>*/}
        {/*                    )}/>*/}
        {/*                  </div>*/}
        {/*                </div>*/}
        {/*              </div>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6"}>*/}
        {/*                {documentFormData.file ? (*/}
        {/*                  <>*/}
        {/*                    <label>{props.t('fieldUploadedFile')}</label>*/}
        {/*                    <p>*/}
        {/*                      /!*<img src={documentFormData.file} className={"w-100 p-mt-2"}/>*!/*/}
        {/*                      <i className={"pi pi-file"}></i> {documentFormData.originalFileName}*/}
        {/*                    </p>*/}
        {/*                  </>*/}
        {/*                ) : (*/}
        {/*                  <>*/}
        {/*                    <label>{props.t('fieldUploadedFile')}</label>*/}
        {/*                    <span className="p-d-block">*/}
        {/*                    {documentFormData && documentFormData.id !== undefined ? (*/}
        {/*                      <p>*/}
        {/*                        <a*/}
        {/*                          href={process.env.REACT_APP_API_HOST + "/employeeDocument/"*/}
        {/*                          + formData.id + "/download/" + documentFormData.id*/}
        {/*                          + "?token=" + localStorage.getItem('userToken') + "."*/}
        {/*                          + localStorage.getItem("networkId")}*/}
        {/*                          target="_blank"*/}
        {/*                        >*/}
        {/*                          <i className={"pi pi-file"}></i> {documentFormData.originalFileName}*/}
        {/*                        </a>*/}
        {/*                      </p>*/}
        {/*                      // <img src={process.env.REACT_APP_API_HOST + "/Companydocument/"*/}
        {/*                      // + formData.id + "/download/" + documentFormData.id*/}
        {/*                      // + "?token=" + localStorage.getItem("userToken") + "."*/}
        {/*                      // + localStorage.getItem('networkId')} className={"w-100 p-mt-2"}/>*/}
        {/*                    ) : (*/}
        {/*                      <p>Még nincs fájl feltöltve.</p>*/}
        {/*                    )}*/}
        {/*                  </span>*/}
        {/*                  </>*/}
        {/*                )}*/}
        {/*                <Field name="file" render={({input, meta}) => (*/}
        {/*                  <div className="p-field">*/}
        {/*                    {!documentFormData.file ? (*/}
        {/*                      <>*/}
        {/*                        <label htmlFor="file"*/}
        {/*                               className={classNames({'p-error': isFormFieldValid(meta)})}>Fájl*/}
        {/*                          feltöltése</label>*/}
        {/*                        <span className="p-d-block">*/}
        {/*                      <FileUpload mode="basic"*/}
        {/*                                  name="file"*/}
        {/*                                  id={"file"}*/}
        {/*                                  auto="true"*/}
        {/*                                  maxFileSize={10000000000}*/}
        {/*                                  customUpload*/}
        {/*                                  uploadHandler={documentUpload}*/}
        {/*                                  chooseLabel={props.t('chooseFile')}*/}
        {/*                                  uploadLabel={props.t('upload')}*/}
        {/*                      />*/}
        {/*                    </span>*/}
        {/*                      </>*/}
        {/*                    ) : (*/}
        {/*                      <>*/}
        {/*                      <span className="p-d-block">*/}
        {/*                      <Button type="button"*/}
        {/*                              className="p-button p-button-danger p-mt-2"*/}
        {/*                              onClick={() => setDocumentFormData({...documentFormData, file: null})}*/}
        {/*                      ><i className={"pi pi-trash"}></i>&nbsp;Törlés</Button>*/}
        {/*                    </span>*/}
        {/*                      </>*/}
        {/*                    )}*/}
        {/*                    {getFormErrorMessage(meta)}*/}
        {/*                  </div>*/}
        {/*                )}/>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={"p-grid p-mt-1"}>*/}
        {/*              <div className={"p-col-12 p-p-0"}>*/}
        {/*                <Message severity="warn" text="*/}
        {/*            Figyelem! A projekthez kapcsolt dokumentum megjelenik a projektgazda számára a projekt adatlapon.*/}
        {/*            "></Message>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={"p-grid p-mt-1"}>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6"}>*/}
        {/*              </div>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>*/}
        {/*                <Button type="submit" label={props.t('save')} icon="pi pi-check"*/}
        {/*                        loading={documentsLoading}/>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*          </form>*/}
        {/*        )}/>*/}
        {/*</Dialog>*/}
        {/*<Dialog visible={contactDialog}*/}
        {/*        style={{width: '750px'}}*/}
        {/*        header="Kapcsolat hozzáadása"*/}
        {/*        modal*/}
        {/*        onHide={() => {*/}
        {/*          setContactDialog(false)*/}
        {/*        }}>*/}
        {/*  <Form onSubmit={contactOnSubmit}*/}
        {/*        initialValues={contactFormData}*/}
        {/*        validate={contactValidate}*/}
        {/*        render={({handleSubmit, submitting}) => (*/}
        {/*          <form onSubmit={handleSubmit} className="">*/}
        {/*            <div className={"p-grid"}>*/}
        {/*              <div className={"p-col-12 p-lg-4 p-xl-4"}>*/}
        {/*                <Field name="name" render={({input, meta}) => (*/}
        {/*                  <div className="p-field p-fluid">*/}
        {/*                    <label htmlFor="name"*/}
        {/*                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>*/}
        {/*                    <span className={"p-d-block"}>*/}
        {/*                      <InputText id="name" {...input}*/}
        {/*                                 onChange={(e) => {*/}
        {/*                                   setContactFormData({*/}
        {/*                                     ...contactFormData,*/}
        {/*                                     name: e.target.value*/}
        {/*                                   })*/}
        {/*                                 }}*/}
        {/*                                 value={contactFormData.name}*/}
        {/*                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
        {/*                    </span>*/}
        {/*                    {getFormErrorMessage(meta)}*/}
        {/*                  </div>*/}
        {/*                )}/>*/}
        {/*              </div>*/}
        {/*              <div className={"p-col-12 p-lg-4 p-xl-4"}>*/}
        {/*                <Field name="email" render={({input, meta}) => (*/}
        {/*                  <div className="p-field p-fluid">*/}
        {/*                    <label htmlFor="email"*/}
        {/*                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldEmail')}</label>*/}
        {/*                    <span className={"p-d-block"}>*/}
        {/*                      <InputText id="email" {...input}*/}
        {/*                                 onChange={(e) => {*/}
        {/*                                   setContactFormData({*/}
        {/*                                     ...contactFormData,*/}
        {/*                                     email: e.target.value*/}
        {/*                                   })*/}
        {/*                                 }}*/}
        {/*                                 value={contactFormData.email}*/}
        {/*                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
        {/*                    </span>*/}
        {/*                    {getFormErrorMessage(meta)}*/}
        {/*                  </div>*/}
        {/*                )}/>*/}
        {/*              </div>*/}
        {/*              <div className={"p-col-12 p-lg-4 p-xl-4"}>*/}
        {/*                <Field name="phone" render={({input, meta}) => (*/}
        {/*                  <div className="p-field p-fluid">*/}
        {/*                    <label htmlFor="phone"*/}
        {/*                           className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPhone')}</label>*/}
        {/*                    <span className={"p-d-block"}>*/}
        {/*                      <InputText id="phone" {...input}*/}
        {/*                                 onChange={(e) => {*/}
        {/*                                   setContactFormData({*/}
        {/*                                     ...contactFormData,*/}
        {/*                                     phone: e.target.value*/}
        {/*                                   })*/}
        {/*                                 }}*/}
        {/*                                 value={contactFormData.phone}*/}
        {/*                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
        {/*                    </span>*/}
        {/*                    {getFormErrorMessage(meta)}*/}
        {/*                  </div>*/}
        {/*                )}/>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*            <div className={"p-grid p-mt-1"}>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6"}>*/}
        {/*              </div>*/}
        {/*              <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>*/}
        {/*                <Button type="submit" label={props.t('save')} icon="pi pi-check"*/}
        {/*                        loading={contactsLoading}/>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*          </form>*/}
        {/*        )}/>*/}
        {/*</Dialog>*/}
      </form>
    )}/>
  )
}
export default withTranslation('common')(CompanyFormComponent);
